// @flow
import { networkInterfaces } from "redux-query";

export const makeRequest = networkInterfaces.superagent;
